module.exports = new __parcel__URL__("Mageskill_48.775ab908.png").toString();